import { render } from "./BankCollectedAddBatch.vue?vue&type=template&id=0cd0d0c1"
import script from "./BankCollectedAddBatch.vue?vue&type=script&lang=js"
export * from "./BankCollectedAddBatch.vue?vue&type=script&lang=js"

import "./BankCollectedAddBatch.vue?vue&type=style&index=0&id=0cd0d0c1&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__